import { memone } from '@deqo/foundation';
import { Physical } from '../entities/Physical';
import { TextAlignment } from '../entities/TextConventions';
import { FieldLayout } from './AdaptableField';
import { TextField } from './TextField';


export class SimpleTextField extends TextField {

    public readonly fontColor: string = '#333';
    public readonly fontFamily: string = 'Inter';
    public readonly fontSize: number = 18;
    public readonly fontStyle: string = 'normal';
    public readonly fontWeight: number = 400;
    public readonly lineHeight: number = 1.25;
    public readonly maxFontSize = null;
    public readonly maxLength = null;
    public readonly textAlignH: TextAlignment = TextAlignment.start;
    public readonly textAlignV: TextAlignment = TextAlignment.start;
    public readonly textMargin: number | number[] = 10;

    public get layout(): FieldLayout {
        const { w, h } = this.owner.cast(Physical).size();
        return this.computeLayout(w, h, this.value);
    }

    @memone()
    protected computeLayout(width: number, height: number, _value: string): FieldLayout {
        return new FieldLayout(0, 0, width, height, 2);
    }
}
